export const Account = {
  properties: {
    FinalUrlSuffix: {
      bulkDeleteValueIfEmpty: true,
    },
  },
};
